<template>
  <div class="detail-section" :class="{ 'section-bordered': bordered }">
    <div v-if="title" class="section-header">
      <component v-if="icon" :is="icon" class="section-icon" />
      <h3 class="section-title">{{ title }}</h3>
    </div>
    <div class="section-content">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title?: string
  icon?: any
  bordered?: boolean
}

withDefaults(defineProps<Props>(), {
  bordered: false
})
</script>

<style scoped lang="less">
.detail-section {
  margin-bottom: 32px;

  &.section-bordered {
    padding: 16px;
    border: 1px solid #f0f0f0;
    border-radius: 6px;
    background: #fafafa;
  }

  .section-header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f0f0f0;

    .section-icon {
      margin-right: 8px;
      font-size: 16px;
      color: #1890ff;
    }

    .section-title {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      color: #262626;
    }
  }

  .section-content {
    // 内容区域样式
  }
}
</style>

